<template>
    <div class="w-full">
        <div class="relative mt-1">
            <div class="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                <svg xmlns="http://www.w3.org/2000/svg" class="w-5 h-5 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 12a4 4 0 10-8 0 4 4 0 008 0zm0 0v1.5a2.5 2.5 0 005 0V12a9 9 0 10-9 9m4.5-1.206a8.959 8.959 0 01-4.5 1.207" />
                </svg>
            </div>
            <input ref="input" :value="value" :type="type" class="block pl-10 w-full border-gray-300 focus:border-indigo-500 rounded-md shadow-sm focus:ring-indigo-500 sm:text-sm" @input="$emit('input', $event.target.value)" />
        </div>
    </div>
</template>

<script>
export default {
    props: ["value", "type"],

    data() {
        return {}
    },

    methods: {
        focus() {
            this.$refs.input.focus()
        },
    },
}
</script>
